import { useDocumentDetails } from 'hooks/useDocumentDetails';
import { LandTitleChange } from 'types/Documents';

export const useLandTitleChange = (id: string | null) => {
  // Use the actual API call
  return useDocumentDetails<LandTitleChange | null>(id);
};
